var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2948 4.92202C18.2055 3.85211 16.8899 3.04049 15.445 2.54708C14.0001 2.05367 12.4629 1.89106 10.9467 2.07127C9.43058 2.25147 7.97427 2.76988 6.6853 3.58823C5.39633 4.40659 4.3076 5.50398 3.4995 6.7994C2.6914 8.09483 2.18456 9.55521 2.01638 11.0727C1.84821 12.5902 2.02301 14.1262 2.52786 15.5671C3.03272 17.008 3.85475 18.3172 4.93327 19.3979C6.01179 20.4786 7.31925 21.3033 8.75915 21.8111C9.12426 21.9341 9.50673 21.9979 9.89201 21.9999C10.7934 21.9999 11.6578 21.6418 12.2952 21.0045C12.9325 20.3671 13.2906 19.5027 13.2906 18.6013V18.2331C13.2906 17.9327 13.4099 17.6445 13.6224 17.4321C13.8348 17.2196 14.123 17.1003 14.4235 17.1003H18.785C19.556 17.1037 20.305 16.8434 20.9077 16.3626C21.5104 15.8818 21.9306 15.2094 22.0986 14.4569C22.278 13.6865 22.3636 12.8972 22.3535 12.1062C22.3443 10.7659 22.0692 9.44079 21.5442 8.20757C21.0191 6.97436 20.2545 5.8576 19.2948 4.92202Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9501,
    cy: 11.0908,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.83223,
    cy: 6.57808,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.8374,
    cy: 6.123,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.27241,
    cy: 11.5459,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.14961,
    cy: 17.0293,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.ab28aba89b0c0b23aed43045b2916d38.svg";
export { ForwardRef as ReactComponent };